import { render, staticRenderFns } from "./FeatureSplit.vue?vue&type=template&id=b95a858a&scoped=true"
import script from "./FeatureSplit.vue?vue&type=script&lang=js"
export * from "./FeatureSplit.vue?vue&type=script&lang=js"
import style0 from "./FeatureSplit.vue?vue&type=style&index=0&id=b95a858a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95a858a",
  null
  
)

export default component.exports